import React from 'react';
import { EngagementController } from './Engagement.controller';
import { gql } from '@apollo/client';
import { useGetPostStatsLazyQuery } from '../../../../models/graphql';
import { AnalyticsVisualizationType } from '../AnalyticsDashboard.controller';

gql`
  query GetPostStats($startDate: String!, $endDate: String!, $selectedProfilesIds: [ID!]!) {
    analyticsPostStats(
      socialProfileIds: $selectedProfilesIds
      rangeStartDate: $startDate
      rangeEndDate: $endDate
      groupByType: PROFILE
      groupByDate: true
    ) {
      postStatsByProfile {
        socialProfileId
        postStats {
          postCount
          rangeStartDate
          rangeEndDate
          likes
          comments
          shares
        }
      }
    }
  }
`;

export const EngagementApollo = ({ view }: { view: AnalyticsVisualizationType }) => {
  const [getData, { data, loading }] = useGetPostStatsLazyQuery();

  return <EngagementController getPostStatsDataQuery={getData} postStats={data} loading={loading} view={view} />;
};
